import Button from "@mui/material/Button";
import React, { useMemo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "./AppBar";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
  ACTIONS,
  getPartRefById,
  getUserImageResourcesByPartRef,
} from "../../../../../Providers/TemplateInstanceProvider";
import { Trans, useTranslation } from "react-i18next";
import TemplateContainer from "./TemplateContainer";
import ToolbarContainer from "./ToolbarContainer";
import ActionsContainer from "./ActionsContainer";
import ToolbarContent from "./ToolbarContent";
import { ToolbarOption, ToolbarOptions } from "./ToolBarOptions";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  button: {
    width: "64px",
    height: "64px",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const [state, dispatch] = useTemplateInstance();
  const { t } = useTranslation();

  const images = useMemo(() => {
    const partRef = getPartRefById(state.currentPartRefId, state.template);
    return getUserImageResourcesByPartRef(partRef, state).filter(
      (resource) => !resource.disableEdit,
    );
  }, [state]);

  const selectResource = (e, resource) => {
    dispatch({
      type: ACTIONS.SET_CURRENT_RESOURCE,
      id: resource.fullId,
    });
    changeMenu("image");
  };

  return (
    <div className={classes.mainContainer}>
      <AppBar onCancel={() => changeMenu("main")} />

      <TemplateContainer
        handleUserImageClick={selectResource}
        mode="select-user-image"
      />

      <ToolbarContainer>
        <ToolbarContent>
          <ToolbarOptions header={t("Choose image")}>
            {images.map((resource, index) => {
              return (
                <ToolbarOption
                  key={resource.id}
                  content={index + 1}
                  onClick={(e) => selectResource(e, resource)}
                />
              );
            })}
          </ToolbarOptions>
        </ToolbarContent>

        <ActionsContainer>
          <Button color="primary" onClick={() => changeMenu("main")}>
            <Trans>Cancel</Trans>
          </Button>
          <Button color="primary" onClick={() => changeMenu("main")}>
            <Trans>Done</Trans>
          </Button>
        </ActionsContainer>
      </ToolbarContainer>
    </div>
  );
};
